const defaultTechStack = [
  'React', 'Next.js', 'Node.js', 'TypeScript', 'Flutter',
  'Python', 'PostgreSQL', 'AWS', 'Docker', 'GraphQL'
]

interface MarqueeProps {
  items?: string[]
}

export default function Marquee({ items = defaultTechStack }: MarqueeProps) {
  // Repeat items to ensure they span far wider than any screen resolution
  const repeatCount = Math.max(6, Math.ceil(30 / Math.max(1, items.length)))
  const safeRepeatCount = repeatCount % 2 === 0 ? repeatCount : repeatCount + 1
  const repeated = Array.from({ length: safeRepeatCount }).flatMap(() => items)

  // Maintain constant speed regardless of repetition count (base 55s for 2 copies)
  const duration = 55 * (safeRepeatCount / 2)

  return (
    <div className="marquee-container">
      <div className="marquee-track" style={{ animationDuration: `${duration}s` }}>
        {repeated.map((item, i) => (
          <span
            key={`${item}-${i}`}
            className="tag-chip whitespace-nowrap"
          >
            {item}
          </span>
        ))}
      </div>
    </div>
  )
}
